import { Link, useNavigate } from '@tanstack/react-router';
import { toast } from 'sonner';
import { PropertyForm } from '@/features/properties/PropertyForm';
import { useCreateProperty } from '@/features/properties/queries';
import { apiErrorMessage } from '@/lib/api';

export function NewPropertyPage() {
  const navigate = useNavigate();
  const createProperty = useCreateProperty();

  return (
    <div className="flex flex-col gap-6">
      <Link to="/biens" className="text-sm text-muted-foreground hover:underline">
        ← Retour aux biens
      </Link>
      <h1 className="text-2xl font-semibold">Nouveau bien</h1>
      <PropertyForm
        isPending={createProperty.isPending}
        submitLabel="Créer le bien"
        onSubmit={(values) => {
          createProperty.mutate(values, {
            onSuccess: (property) => {
              void navigate({ to: '/biens/$propertyId', params: { propertyId: String(property.id) } });
            },
            onError: (error) => {
              toast.error(apiErrorMessage(error, 'Échec de la création'));
            },
          });
        }}
      />
    </div>
  );
}
